export enum DocumentAction {
  DELETE = 'documents:delete',
  DOWNLOAD = 'documents:download',
  CREATE = 'documents:create',
  UPLOAD = 'documents:upload',
  LIST = 'documents:list',
}

export enum DocumentType {
  DOCUMENT = 'document',
  CONTRACT = 'contract',
  EXPENSE = 'expense',
}

export type BaseDocumentItem = {
  linkToDocument: string | null;
  type: DocumentType;
  title: string;
  description?: string;
  userId?: string;
  tenantId?: string;
  metadata?: {
    status: string;
    version: number;
  };
};

export type DocumentItem = BaseDocumentItem & {
  scanStatus: string;
  id: string;
  ownerId: string;
  createdAt: string;
  scannedAt?: string;
  actions: DocumentAction[];
};

export type Documents = {
  items: DocumentItem[];
  actions: DocumentAction[];
};

export type DocumentCreation = {
  id: string;
  message: string;
  url: string;
};

export type DocumentPresignedDetails = {
  url: string;
  fields: Record<string, unknown>;
};
